module.exports = __webpack_public_path__ + "img/home_banner.fada78e.png";